export default {"src":"/_next/static/media/weight-loss.ef1a4c2b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};